import Hero from './Hero';
import Products from './Products_Section';

const Productss = ({
  selectedType,
  teemka,
  countt,
  filteredProducts,
  handleTypeChange,
  loading,
  cartItems,
  setCartItems,
  quantities,
  setQuantities,
}) => {
  return (
    <div>
      <Hero typ={handleTypeChange} />
      {loading ? (
        // Loading spinner and message
        <div className="flex flex-col items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
          <p className="mt-4 text-[#333333] text-lg">Loading perfect socks...</p>
        </div>
      ) : (
        <Products
          selectedType={selectedType}
          teemka={teemka}
          counting={countt}
          types={filteredProducts}
          cartItems={cartItems}
          setCartItems={setCartItems}
          quantities={quantities}
          setQuantities={setQuantities}
        />
      )}
    </div>
  );
};

export default Productss;